import React from "react";
import { mergeStyles, Text } from "office-ui-fabric-react"
import OrderDetailTxt from "./forms/edditOrder/OrderDetailTxt";
import OrderDetailLink from "./forms/edditOrder/OrderDetailLink";
import { RootStateOrAny, useSelector } from "react-redux";
import { Reason } from "../../common/enums/reason.enum";
import { getReasonsById } from "../../../connectors/cancellationReasons/connectors";
import { useQuery } from "react-query";
import { OrderTypeNumber, OrderTypeString, translateOrderTypeName } from "../../common/enums/orderTypes.enum";
import { useTranslation } from "react-i18next";
import { translateCuoTireTypeName } from "../../common/enums/cuoTireTypes.enum";
import { translateAdditionalInfo } from "../actions/translateAdditionalInfo";
import {
  cuoSectionContainer,
  cuoSectionTitle,
  cuoSubsectionTitle,
  cuoGridTwoColumns,
  cuoGridThreeColumns,
  cuoSubsection
} from "../styles/detailTxt.style";

const wrapper = mergeStyles({
  padding: 20
})

const decodeHtmlEntities = (text: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

const OrderDetails: React.FC = () => {
  const { t } = useTranslation("admin");
  const { orderDetails } = useSelector((state: RootStateOrAny) => state.orderPanel)
  // OptimaStatus enum value -> label (the API name is in Polish)
  const optimaStatusLabels: { [status: number]: string } = {
    0: t("orders.optimaStatus.notSynchronized"),
    1: t("orders.optimaStatus.synchronized"),
    2: t("orders.optimaStatus.error"),
    3: t("orders.optimaStatus.manuallySynchronized"),
  };
  const { data } = useQuery(
    ["reasonForCancellation", Reason.OrderCancel],
    getReasonsById
  );
  let cancelReason = undefined;
  if (data) {
    for (let reason of data.data.data) {
      if (reason.id === orderDetails.reasonForCancellation) {
        cancelReason = reason.value
      }
    }
  }

  return (
    <div className={wrapper}>
      {orderDetails && (
        <div>
          <OrderDetailTxt
            title={t("orders.details.orderNumber") as string}
            value={orderDetails.orderInfo.number}
          />
          <OrderDetailTxt
            title={t("orders.details.clientName") as string}
            value={orderDetails.orderInfo.company}
          />
          <OrderDetailTxt
            title={t("orders.details.address") as string}
            value={orderDetails.orderInfo.receptionPlace}
          />
          <OrderDetailTxt
            title={t("orders.details.contactPhone") as string}
            value={orderDetails.orderInfo.receptionPlacePhone}
          />
          <OrderDetailTxt
            title={t("orders.details.orderType") as string}
            value={translateOrderTypeName(orderDetails.orderInfo.type, t)}
          />
          <OrderDetailTxt
            title={t("orders.details.vehicle") as string}
            value={orderDetails.orderInfo.vehicle ? orderDetails.orderInfo.vehicle : t("orders.details.none") as string}
          />
          <OrderDetailTxt
            title={t("orders.details.additionalInfo") as string}
            value={orderDetails.additionalInfo ? translateAdditionalInfo(orderDetails.additionalInfo) : t("orders.details.none") as string}
          />
          <OrderDetailTxt
            title={t("orders.details.paymentType") as string}
            value={orderDetails.paymentType === 0 ? t("orders.details.cash") as string : t("orders.details.transfer") as string}
          />
          <OrderDetailTxt
            title={t("orders.details.quantity") as string}
            value={orderDetails.orderInfo.quantity}
          />

          {orderDetails.cuoOrderDetails && orderDetails.tireQuantity && (
            <OrderDetailTxt
              title={t("orders.details.tireQuantity") as string}
              value={`${orderDetails.tireQuantity} ${t("orders.details.unit")}`}
            />
          )}





          {orderDetails.netPrice != null && orderDetails.netPrice > 0 && <OrderDetailTxt
            title={orderDetails.orderTypeId == OrderTypeNumber.Tonnage ? t("orders.details.netPricePerTon") as string : t("orders.details.netPrice") as string}
            value={(orderDetails.netPrice).toFixed(2).toString()}
          />}
          {orderDetails.grossPrice != null && orderDetails.grossPrice > 0 && <OrderDetailTxt
            title={orderDetails.orderTypeId == OrderTypeNumber.Tonnage ? t("orders.details.grossPricePerTon") as string : t("orders.details.grossPrice") as string}
            value={(orderDetails.grossPrice).toFixed(2).toString()}
          />}
          {orderDetails.orderTypeId != OrderTypeNumber.Tonnage ?
            <>
              {orderDetails.netValue != null && orderDetails.netValue > 0 &&
                <OrderDetailTxt
                  title={t("orders.details.netValue") as string}
                  value={orderDetails.netValue.toFixed(2).toString()}
                />}
              {orderDetails.grossValue != null && orderDetails.grossValue > 0 &&
                <OrderDetailTxt
                  title={t("orders.details.grossValue") as string}
                  value={(orderDetails.grossValue).toFixed(2).toString()}
                />}
            </> : <></>}
          {orderDetails.kpo && <OrderDetailTxt
            title={t("orders.details.kpo") as string}
            value={orderDetails.kpo}
          />}
          {orderDetails.tonnage && <OrderDetailTxt
            title={t("orders.details.tonnage") as string}
            value={orderDetails.tonnage}
          />}
          {orderDetails.internalStoreName && <OrderDetailTxt
            title={t("orders.details.internalStore") as string}
            value={orderDetails.internalStoreName}
          />}
          {orderDetails.recycleOperatorName && <OrderDetailTxt
            title={t("orders.details.operator") as string}
            value={orderDetails.recycleOperatorName}
          />}
          {orderDetails.optimaStatusName && orderDetails.recycleOperatorName && <OrderDetailTxt
            title={t("orders.details.optimaSyncStatus") as string}
            value={optimaStatusLabels[orderDetails.optimaStatus] || orderDetails.optimaStatusName}
          />}
          {orderDetails.optimaNumber && <OrderDetailTxt
            title={t("orders.details.optimaNumber") as string}
            value={orderDetails.optimaNumber}
          />}
          {orderDetails.invoiceNumber && <OrderDetailTxt
            title={t("orders.details.invoiceNumber") as string}
            value={orderDetails.invoiceNumber}
          />}
          {cancelReason ? <OrderDetailTxt
            title={t("orders.details.cancellationReason") as string}
            value={cancelReason}
          /> : null}



          {orderDetails.cuoOrderDetails && (
            <div className={cuoSectionContainer}>
              <Text styles={cuoSectionTitle}>{t("orders.details.cuoSection")}</Text>

              <div className={cuoGridTwoColumns}>
                <OrderDetailTxt
                  title={t("orders.details.cuoOrderNumber") as string}
                  value={orderDetails.cuoOrderDetails.cuoOrderNumber}
                />
                {orderDetails.cuoOrderDetails.cuoOrderDate && (
                  <OrderDetailTxt
                    title={t("orders.details.cuoOrderDate") as string}
                    value={new Date(orderDetails.cuoOrderDetails.cuoOrderDate).toLocaleDateString('pl-PL')}
                  />
                )}
              </div>

              <div className={cuoSubsection}>
                <Text styles={cuoSubsectionTitle}>{t("orders.details.realizationSummary")}</Text>
                <div className={cuoGridTwoColumns}>
                  <OrderDetailTxt
                    title={t("orders.details.orderedTires") as string}
                    value={`${orderDetails.cuoOrderDetails.totalTiresOrdered} ${t("orders.details.unit")}`}
                  />
                  <OrderDetailTxt
                    title={t("orders.details.realizedTires") as string}
                    value={`${orderDetails.cuoOrderDetails.totalTiresRealized} ${t("orders.details.unit")}`}
                  />
                  <OrderDetailTxt
                    title={t("orders.details.sodoOrders") as string}
                    value={`${orderDetails.cuoOrderDetails.totalSodoOrders} ${t("orders.details.unit")}`}
                  />
                  <OrderDetailTxt
                    title={t("orders.details.realizedOrders") as string}
                    value={`${orderDetails.cuoOrderDetails.realizedSodoOrders} ${t("orders.details.unit")}`}
                  />
                </div>
              </div>

              {orderDetails.cuoOrderDetails.positions && orderDetails.cuoOrderDetails.positions.length > 0 && (
                <div className={cuoSubsection}>
                  <Text styles={cuoSubsectionTitle}>{t("orders.details.orderPositions")}</Text>
                  <div className={cuoGridThreeColumns}>
                    {orderDetails.cuoOrderDetails.positions.map((position: any, index: number) => {
                      const isSpecial = position.name && (
                        position.name.toLowerCase().includes('specjalne')
                      );
                      const displayValue = isSpecial
                        ? `${t("orders.details.ordered")}: ${position.quantity} ${t("orders.details.unit")}`
                        : `${t("orders.details.ordered")}: ${position.quantity} ${t("orders.details.unit")} | ${t("orders.details.realized")}: ${position.quantityRealized} ${t("orders.details.unit")}`;

                      return (
                        <div key={index}>
                          <OrderDetailTxt
                            title={translateCuoTireTypeName(position.name)}
                            value={displayValue}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {orderDetails.cuoOrderDetails.description && (
                <div className={cuoSubsection}>
                  <OrderDetailTxt
                    title={t("orders.details.orderDescription") as string}
                    value={decodeHtmlEntities(orderDetails.cuoOrderDetails.description)}
                  />
                </div>
              )}

              {(orderDetails.cuoOrderDetails.clientName || orderDetails.cuoOrderDetails.firmName ||
                orderDetails.cuoOrderDetails.address || orderDetails.cuoOrderDetails.phone) && (
                <div className={cuoSubsection}>
                  <Text styles={cuoSubsectionTitle}>{t("orders.details.clientData")}</Text>
                  <div className={cuoGridTwoColumns}>
                    {orderDetails.cuoOrderDetails.clientName && (
                      <OrderDetailTxt
                        title={t("orders.details.cuoClient") as string}
                        value={orderDetails.cuoOrderDetails.clientName}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.firmName && (
                      <OrderDetailTxt
                        title={t("orders.details.collectionOrderer") as string}
                        value={orderDetails.cuoOrderDetails.firmName}
                      />
                    )}

                    {orderDetails.cuoOrderDetails.address && (
                      <OrderDetailTxt
                        title={t("orders.details.cuoAddress") as string}
                        value={orderDetails.cuoOrderDetails.address}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.phone && (
                      <OrderDetailTxt
                        title={t("orders.details.cuoPhone") as string}
                        value={orderDetails.cuoOrderDetails.phone}
                      />
                    )}
                  </div>
                </div>
              )}

              {(orderDetails.cuoOrderDetails.regionName || orderDetails.cuoOrderDetails.operatorName ||
                orderDetails.cuoOrderDetails.pickupDate || orderDetails.cuoOrderDetails.statusName) && (
                <div className={cuoSubsection}>
                  <Text styles={cuoSubsectionTitle}>{t("orders.details.operationalInfo")}</Text>
                  <div className={cuoGridTwoColumns}>
                    {orderDetails.cuoOrderDetails.regionName && (
                      <OrderDetailTxt
                        title={t("orders.details.region") as string}
                        value={orderDetails.cuoOrderDetails.regionName}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.operatorName && (
                      <OrderDetailTxt
                        title={t("orders.details.cuoOperator") as string}
                        value={orderDetails.cuoOrderDetails.operatorName}
                      />
                    )}
                    {orderDetails.cuoOrderDetails.pickupDate && (
                      <OrderDetailTxt
                        title={t("orders.details.cuoPickupDate") as string}
                        value={new Date(orderDetails.cuoOrderDetails.pickupDate).toLocaleDateString('pl-PL')}
                      />
                    )}

                  </div>
                </div>
              )}

              <div className={cuoGridTwoColumns}>
                <OrderDetailTxt
                  title={t("orders.details.cuoReportStatus") as string}
                  value={orderDetails.cuoDeliveryReportSent ? t("orders.details.sent") as string : t("orders.details.notSent") as string}
                />
                {orderDetails.cuoDeliveryReportSentAt && (
                  <OrderDetailTxt
                    title={t("orders.details.reportSentDate") as string}
                    value={new Date(orderDetails.cuoDeliveryReportSentAt).toLocaleString('pl-PL')}
                  />
                )}

                {orderDetails.cuoOrderDetails.cuoOrderId && (
                  <OrderDetailLink
                    title={t("orders.details.cuoOrderLink") as string}
                    url={`https://app.utylizacjaopon.pl/Order/View/${orderDetails.cuoOrderDetails.cuoOrderId}`}
                  />
                )}
              </div>
            </div>
          )}

        </div>
      )}
    </div>
  );
};

export default OrderDetails;